import { useEffect, useState } from 'react';
import axios from 'axios';
import AgentProfile from './AgentProfile';
import PackageUpload  from "./PackageUploadByAgent"
// import { MenuIcon, XIcon } from '@heroicons/react/solid'; // Assuming Heroicons for menu toggle

// Placeholder CreatePackage component
function CreatePackage() {
  const [packageData, setPackageData] = useState({
    title: '',
    description: '',
    price: '',
  });

  const handleChange = (e) => {
    setPackageData({ ...packageData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Placeholder for package submission logic
    console.log('Package submitted:', packageData);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-4 mt-20">Create New Package</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1">
            Package Title
          </label>
          <input
            id="title"
            name="title"
            placeholder="Enter package title"
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors bg-gray-50"
          />
        </div>
        <div>
          <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
            Description
          </label>
          <textarea
            id="description"
            name="description"
            placeholder="Enter package description"
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors bg-gray-50"
            rows="4"
          />
        </div>
        <div>
          <label htmlFor="price" className="block text-sm font-medium text-gray-700 mb-1">
            Price
          </label>
          <input
            id="price"
            name="price"
            type="number"
            placeholder="Enter price"
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors bg-gray-50"
          />
        </div>
        <button
          type="submit"
          className="w-full py-2 px-4 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-300"
        >
          Create Package
        </button>
      </form>
    </div>
  );
}

export default function AgentDashboard() {
  const [agent, setAgent] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('create-package');

  useEffect(() => {
    const fetchAgent = async () => {
      const token = localStorage.getItem('token');
      try {
        const res = await axios.get('http://localhost:5000/api/agent/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAgent(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchAgent();
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const renderContent = () => {
    switch (activeSection) {
      case 'create-package':
        return <PackageUpload />;
      case 'view-bookings':
        return (
          <div className="bg-white p-6 rounded-lg shadow-md max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Package Bookings</h2>
            <p className="text-gray-600">No bookings available yet. (Placeholder)</p>
          </div>
        );
      case 'update-profile':
        return agent ? <AgentProfile agent={agent} onUpdate={setAgent} /> : <p>Loading profile...</p>;
      default:
        return <CreatePackage />;
    }
  };

  if (!agent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <p className="text-lg text-gray-600">Loading your dashboard...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 bg-white shadow-lg transform ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } md:relative md:translate-x-0 w-64 transition-transform duration-300 ease-in-out z-20`}
      >
        <div className="p-4 border-b">
          <h2 className="text-xl font-bold text-gray-800">Agent Dashboard</h2>
          <button
            className="md:hidden absolute top-4 right-4 text-gray-600 hover:text-gray-800"
            onClick={toggleSidebar}
          >
            {/* <XIcon className="h-6 w-6" /> */}
          </button>
        </div>
        <nav className="mt-4">
          <button
            onClick={() => setActiveSection('create-package')}
            className={`w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors ${
              activeSection === 'create-package' ? 'bg-blue-50 text-blue-600' : ''
            }`}
          >
            Create Package
          </button>
          <button
            onClick={() => setActiveSection('view-bookings')}
            className={`w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors ${
              activeSection === 'view-bookings' ? 'bg-blue-50 text-blue-600' : ''
            }`}
          >
            View Bookings
          </button>
          <button
            onClick={() => setActiveSection('update-profile')}
            className={`w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors ${
              activeSection === 'update-profile' ? 'bg-blue-50 text-blue-600' : ''
            }`}
          >
            Update Profile
          </button>
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <header className="bg-white shadow-md p-4 flex justify-between items-center">
          <button className="md:hidden text-gray-600 hover:text-gray-800" onClick={toggleSidebar}>
            {/* <MenuIcon className="h-6 w-6" /> */}
          </button>
          <div className="flex items-center space-x-4">
            <div className="text-gray-800 font-semibold">{agent.username}</div>
            <div className="h-10 w-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold">
              {agent.username?.charAt(0).toUpperCase()}
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="flex-1 p-6 overflow-y-auto">
          {renderContent()}
        </main>
      </div>

      {/* Sidebar Overlay for Mobile */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 md:hidden z-10"
          onClick={toggleSidebar}
        ></div>
      )}
    </div>
  );
}